import { TExhibitorData } from '../../Context/AuthContex/ExhibitorAuthContext';
import {
  EXHIBITOR_USER_FAILED,
  EXHIBITOR_USER_SUCCESS,
  USER_PROFILE_UPDATE,
} from '../../Helpers/Constant';

const exhibitorReducer = (state: TExhibitorData, action: any) => {
  switch (action.type) {
    case EXHIBITOR_USER_SUCCESS:
      return {
        ...state,
        exhibitorUser: action.payload,
      };
    case USER_PROFILE_UPDATE:
      const updateUser = { ...state.exhibitorUser, ...action.payload };
      return { ...state, exhibitorUser: updateUser };
    case EXHIBITOR_USER_FAILED:
      localStorage.removeItem('toab_exibitor_token');
      return { ...state, exhibitorUser: {} };
    default:
      throw new Error(`No matching action type - ${action.type}`);
  }
};

export default exhibitorReducer;
